import { Injectable } from "@angular/core";
import { ToastrService } from 'ngx-toastr';
import { FuiModalService } from 'ngx-fomantic-ui';
import { ConfirmModal } from '../../dialog/components/confirm-modal/confirm-modal.component';
import { Observable } from 'rxjs';
import { IConfirmModalContext, IModalOptions } from '../models';

export interface IAlertFacadeOption {
    title: string;
    message?: string;
    tapToDismiss?: boolean;
    timeOut?: number;
    type: 'info' | 'warning' | 'error' | 'success'
    position: 'top right' | 'top left' | 'bottom right' | 'bottom left' | 'top center' | 'bottom center'
}

@Injectable()
export class AlertFacadeService {
    constructor(private toastr: ToastrService) {

    }

    showMessage(options: IAlertFacadeOption) : void {
        const positionClass = this.resolvePositionClass(options.position);

        this.toastr.show(options.message, options.title, {
            tapToDismiss: options.tapToDismiss,
            timeOut: options.timeOut,
            positionClass: positionClass
        }, `toast-${options.type}`);
    }

    resolvePositionClass(position: 'top right' | 'top left' | 'bottom right' | 'bottom left' | 'top center' | 'bottom center'): string {

        if (!position)
            return 'toast-bottom-right';

        return `toast-${position.replace(' ', '-')}`;
    }
}